import { render } from "./PassengerClause.vue?vue&type=template&id=5c6cf693&scoped=true"
const script = {}

import "./PassengerClause.vue?vue&type=style&index=0&id=5c6cf693&lang=scss&scoped=true"

import exportComponent from "D:\\肖虹\\软件工程与UML\\《软件工程》\\UML面向对象分析，建模和设计\\项目案例\\机票预订系统的文档与代码（前后端分离）\\源代码\\前端代码\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c6cf693"]])

export default __exports__